var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHubspot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "52.00000000000005 47.99999999999999 146.884 152.176",
    width: 142.88,
    height: 148.18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M156.8 155.78C145.73 155.78 136.76 146.9 136.76 135.95C136.76 124.99 145.73 116.12 156.8 116.12C167.87 116.12 176.84 124.99 176.84 135.95C176.84 146.9 167.87 155.78 156.8 155.78M162.8 97.77C162.8 87.18 162.8 81.3 162.8 80.13C167.45 77.95 170.71 73.29 170.71 67.89C170.71 67.85 170.71 67.52 170.71 67.48C170.71 60.02 164.54 53.92 157 53.92C156.96 53.92 156.63 53.92 156.59 53.92C149.05 53.92 142.88 60.02 142.88 67.48C142.88 67.52 142.88 67.85 142.88 67.89C142.88 73.29 146.14 77.95 150.8 80.13C150.8 81.89 150.8 96 150.8 97.77C143.87 98.83 137.54 101.66 132.32 105.82C127.42 102.05 88.27 71.91 83.37 68.14C83.7 66.91 83.92 65.65 83.92 64.32C83.93 55.87 77.02 49.01 68.48 49C59.94 48.99 53.01 55.83 53 64.28C52.99 72.73 59.9 79.59 68.44 79.6C71.22 79.61 73.8 78.82 76.06 77.55C80.87 81.26 119.39 110.91 124.2 114.62C120.11 120.73 117.71 128.06 117.71 135.95C117.71 144.2 120.35 151.84 124.8 158.12C123.34 159.57 111.62 171.16 110.16 172.61C109 172.27 107.8 172.03 106.53 172.03C99.51 172.03 93.82 177.66 93.82 184.6C93.82 191.55 99.51 197.18 106.53 197.18C113.55 197.18 119.24 191.55 119.24 184.6C119.24 183.35 118.99 182.16 118.65 181.01C120.09 179.58 131.68 168.11 133.13 166.68C139.7 171.64 147.89 174.63 156.8 174.63C178.39 174.63 195.88 157.31 195.88 135.95C195.88 116.61 181.53 100.63 162.8 97.77",
    id: "cayyrSyXb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cayyrSyXb",
    opacity: 1,
    fill: "#ff7a59",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cayyrSyXb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/hubspot.3ea6e790618030fc367ff04eb7c50c1f.svg";
export { ForwardRef as ReactComponent };